import React, { useState, useEffect, useCallback } from "react";

const ANNIVERSARY_DATE = new Date("2026-09-01T00:00:00");

function getTimeLeft() {
  const now = new Date();
  const diff = ANNIVERSARY_DATE - now;

  if (diff <= 0) return null; // Date has passed

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
}

function AnniversaryBanner({ storageKey = "anniv_banner_dismissed" }) {
  const [visible, setVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const dismissed = sessionStorage.getItem(storageKey);
    if (dismissed) setVisible(false);
  }, [storageKey]);

  useEffect(() => {
    if (!visible) return;
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [visible]);

  const handleDismiss = useCallback(() => {
    setVisible(false);
    sessionStorage.setItem(storageKey, "true");
  }, [storageKey]);

  if (!visible || !timeLeft) return null;

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="anniv-banner" role="banner" aria-label="LMCS 5th Anniversary announcement">
      {/* Animated sparkle particles */}
      <div className="anniv-particles" aria-hidden="true">
        {[...Array(8)].map((_, i) => (
          <span key={i} className={`anniv-particle anniv-particle-${i + 1}`} />
        ))}
      </div>

      <div className="anniv-content">
        {/* Left: Anniversary image */}
        <div className="anniv-img-wrap" aria-hidden="true">
          <img
            src="img/lmcs-5th-anniversary.jpeg"
            alt="LMCS 5th Anniversary"
            className="anniv-img"
          />
        </div>

        {/* Center: Main text */}
        <div className="anniv-text">
          <div className="anniv-headline">
            <span className="anniv-star" aria-hidden="true">★</span>
            <span>
              Celebrating <strong>LMCS 5th Anniversary</strong> &mdash; 2021&ndash;2026
            </span>
            <span className="anniv-star" aria-hidden="true">★</span>
          </div>
          <div className="anniv-sub">
            1st September 2021 &rarr; 1st September 2026
          </div>
        </div>

        {/* Right: Countdown */}
        <div className="anniv-countdown" aria-label="Time remaining to anniversary">
          {[
            { label: "Days", value: pad(timeLeft.days) },
            { label: "Hrs", value: pad(timeLeft.hours) },
            { label: "Min", value: pad(timeLeft.minutes) },
            { label: "Sec", value: pad(timeLeft.seconds) },
          ].map(({ label, value }) => (
            <div className="anniv-unit" key={label}>
              <span className="anniv-unit-num">{value}</span>
              <span className="anniv-unit-label">{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Dismiss */}
      <button
        className="anniv-close"
        onClick={handleDismiss}
        aria-label="Dismiss anniversary banner"
        title="Dismiss"
      >
        &times;
      </button>
    </div>
  );
}

export default AnniversaryBanner;
